import React from "react";
import {
  DesktopDropdown,
  DesktopDropdownItem,
  DesktopMenu,
  DesktopNavItem,
  LoginButton,
  NavButton,
  NavLinks,
} from "./Styles";
import { navigation, NavItem } from "./NavigationData";

interface DesktopNavigationProps {
  onLogin: () => void;
}

export const DesktopNavigation = ({
  onLogin,
}: DesktopNavigationProps) => {
  const handleNavigation = (item: NavItem) => {
    if (item.href) {
      window.location.href = item.href;
    }
  };

  return (
    <DesktopMenu>
      <NavLinks>
        {navigation.map((item) => {
          if (item.children) {
            return (
              <DesktopNavItem key={item.label} data-test="navItemLabel">
                <NavButton data-test="navLinks">
                  {item.label}
                </NavButton>

                <DesktopDropdown className="desktop-dropdown">
                  {item.children.map((child) => (
                    <DesktopDropdownItem
                      key={child.label}
                      href={child.href}
                      data-test="desktopNavDropdown"
                    >
                      {child.label}
                    </DesktopDropdownItem>
                  ))}
                </DesktopDropdown>
              </DesktopNavItem>
            );
          }

          return (
            <NavButton
              key={item.label}
              onClick={() => handleNavigation(item)}
              data-test="navButtons"
            >
              {item.label}
            </NavButton>
          );
        })}

        <LoginButton onClick={onLogin} data-test="loginButton">
          LOGIN
        </LoginButton>
      </NavLinks>
    </DesktopMenu>
  );
};

